import Box from '@mui/system/Box';
import { SxProps } from '@mui/system/styleFunctionSx';
import { IMAGES } from 'config/images';
import { Layout } from 'modules/minimal-ui-theme';
import { AppButton } from '../../AppButton';
import { Text } from '../../Text';
import {
  ZENJOB_ERROR_PIC_ALT_TEXT,
  ZENJOB_PURPLE_LOGO_ALT_TEXT
} from '../constants';

const containerStyles: SxProps = {
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'space-between',
  alignItems: 'center',
  height: 1,
  maxHeight: '100%',
  textAlign: 'center'
};

const textContainerStyles = {
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  maxWidth: '500px'
};

export const ErrorScreen = ({
  title,
  description1,
  description2,
  buttonText,
  onButtonClick
}: {
  title: string;
  description1: string;
  description2: string;
  buttonText?: string;
  onButtonClick?: () => void;
}) => {
  const layoutStyles =
    buttonText && !!onButtonClick
      ? containerStyles
      : {
          ...containerStyles,
          height: '90vh',
          paddingTop: '80px',
          marginBottom: '-200px'
        };

  return (
    <Layout childrenStyles={layoutStyles}>
      <img
        alt={ZENJOB_PURPLE_LOGO_ALT_TEXT}
        src={IMAGES.proLogoPurple}
        style={{
          maxWidth: '30vw',
          maxHeight: '7vh',
          paddingBottom: '10px'
        }}
      />
      <br />
      <img alt={ZENJOB_ERROR_PIC_ALT_TEXT} src={IMAGES.cloudface} />
      <br />
      <Box sx={textContainerStyles}>
        <Text variant="h4">{title}</Text>
        <Text>{description1}</Text>
        <Text>{description2}</Text>
        <br />
        {buttonText && !!onButtonClick && (
          <AppButton
            sx={{
              margin: '0 auto',
              width: 'fit-content',
              paddingLeft: '16px',
              paddingRight: '16px'
            }}
            onClick={onButtonClick}
            variant="contained"
            color="primary"
          >
            {buttonText}
          </AppButton>
        )}
      </Box>
    </Layout>
  );
};
